import { render, staticRenderFns } from "./FaxDetail.vue?vue&type=template&id=39450cb2&scoped=true&"
import script from "./FaxDetail.vue?vue&type=script&lang=js&"
export * from "./FaxDetail.vue?vue&type=script&lang=js&"
import style0 from "./FaxDetail.vue?vue&type=style&index=0&id=39450cb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39450cb2",
  null
  
)

export default component.exports